// src/utils/safeToast.js
import React from 'react';
import toast from 'react-hot-toast';
import { parseResponseMsg } from './parseError';

/**
 * دالة مساعدة لفحص الرسالة:
 * إذا كانت كائناً عادياً (مثل {ar, en} أو كائن خطأ) وليست عنصر React،
 * يتم تحويلها تلقائياً إلى نص آمن حسب لغة المستخدم لمنع انهيار ريآكت (React Error #31).
 */
const sanitizeToastMessage = (message) => {
  if (message && typeof message === 'object' && !React.isValidElement(message)) {
    return parseResponseMsg(message);
  }
  return message;
};

// حماية دوال react-hot-toast الأساسية
const originalSuccess = toast.success;
toast.success = (message, options) => {
  return originalSuccess(sanitizeToastMessage(message), options);
};

const originalError = toast.error;
toast.error = (message, options) => {
  return originalError(sanitizeToastMessage(message), options);
};

const originalLoading = toast.loading;
toast.loading = (message, options) => {
  return originalLoading(sanitizeToastMessage(message), options);
};

export default toast;

